module.exports = __webpack_public_path__ + "img/skeleton-orders.19b2bba1.png";